/**
 * @prettier
 * @flow
 */
import { Environments } from 'src/constants/Environment';
import { envENVIRONMENT } from 'src/env/envENVIRONMENT';

let cryptoKeys = {};
if (envENVIRONMENT() === Environments.PROD) {
    cryptoKeys = {
        ENCRYPTION_DATA_IN_TRANSIT_PUBLIC_KEY: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAKuYcsRuLJF+4pK0p1HXqJAni//6xTuOUtWwtbyxqmaXb8/gqL3UGqI49PB8KsOWJbDFp+vq3qE/Do+vQKQPrTcCAwEAAQ==',
    };
} else if (envENVIRONMENT() === Environments.TEST) {
    cryptoKeys = {
        ENCRYPTION_DATA_IN_TRANSIT_PUBLIC_KEY: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAI6LRZ+msdiGpNk/35yqDv3pv2w9/AOHNjwCG8oyHNHmKej10tXojLEwR94dyoWGNSlKv8LIF8Y5KyVfprcoXKUCAwEAAQ==',
    };
} else if (envENVIRONMENT() === Environments.LOCALHOST) {
    cryptoKeys = {
        ENCRYPTION_DATA_IN_TRANSIT_PUBLIC_KEY: 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAI6LRZ+msdiGpNk/35yqDv3pv2w9/AOHNjwCG8oyHNHmKej10tXojLEwR94dyoWGNSlKv8LIF8Y5KyVfprcoXKUCAwEAAQ==',
    };
} else {
    throw new Error(`Can’t configure CryptoConfig, Unknown environment=∞${envENVIRONMENT()}`);
}

export { cryptoKeys };
